// HOT SALE block v6.1 - parser MXN correto - DISCOUNT atualizado para 119
(function(){
  'use strict';
  var VERSION = '6.1';
  var DISCOUNT = 119;
  var injected = false;
  var attempts = 0;

  console.log('[BellaSirena] HOT SALE v' + VERSION + ' loaded');

  function fmt(v){
    return v.toLocaleString('es-MX', {minimumFractionDigits:2, maximumFractionDigits:2});
  }

  function parseMoney(text){
    if (!text) return null;
    var clean = text.replace(/[^\d.,]/g, '');
    if (!clean) return null;
    var lastComma = clean.lastIndexOf(',');
    var lastDot = clean.lastIndexOf('.');
    var result = clean;

    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) {
        result = clean.replace(/\./g, '').replace(',', '.');
      } else {
        result = clean.replace(/,/g, '');
      }
    } else if (lastDot > -1) {
      var afterDot = clean.length - 1 - lastDot;
      if (afterDot === 2) {
        result = clean;
      } else if (afterDot === 3) {
        result = clean.replace(/\./g, '');
      }
    } else if (lastComma > -1) {
      var afterComma = clean.length - 1 - lastComma;
      if (afterComma === 2) {
        result = clean.replace(',', '.');
      } else if (afterComma === 3) {
        result = clean.replace(/,/g, '');
      }
    }
    var val = parseFloat(result);
    return isNaN(val) ? null : val;
  }

  function getPrice(){
    try {
      var scripts = document.querySelectorAll('script[type="application/json"]');
      for (var i=0; i<scripts.length; i++){
        try {
          var raw = scripts[i].textContent;
          if (!raw) continue;
          var data = JSON.parse(raw);
          if (data && typeof data.price === 'number' && data.price > 0) {
            var p = data.price >= 10000 ? data.price/100 : data.price;
            if (p >= 50 && p <= 99999) {
              console.log('[BellaSirena] price from JSON:', p, '(raw:', data.price + ')');
              return p;
            }
          }
          if (data && data.variants && data.variants.length) {
            var vp = data.variants[0].price;
            if (typeof vp === 'number') {
              var p2 = vp >= 10000 ? vp/100 : vp;
              if (p2 >= 50 && p2 <= 99999) {
                console.log('[BellaSirena] price from variants JSON:', p2);
                return p2;
              }
            }
          }
        } catch(e){}
      }
    } catch(e){}

    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        var prod = window.ShopifyAnalytics.meta.product;
        if (prod.variants && prod.variants[0] && prod.variants[0].price) {
          var p3 = prod.variants[0].price;
          var v3 = p3 >= 10000 ? p3/100 : p3;
          if (v3 >= 50 && v3 <= 99999) return v3;
        }
      }
    } catch(e){}

    try {
      var meta = document.querySelector('meta[property="og:price:amount"], meta[itemprop="price"]');
      if (meta && meta.content) {
        var p4 = parseFloat(meta.content);
        if (!isNaN(p4) && p4 >= 50 && p4 <= 99999) {
          console.log('[BellaSirena] price from meta:', p4);
          return p4;
        }
      }
    } catch(e){}

    try {
      var sels = ['[data-product-price]', '.price-item--sale', '.price__sale', '.product__price', '.price'];
      for (var k=0; k<sels.length; k++){
        var els = document.querySelectorAll(sels[k]);
        for (var j=0; j<els.length; j++){
          var p5 = parseMoney(els[j].textContent);
          if (p5 !== null && p5 >= 50 && p5 <= 99999) {
            console.log('[BellaSirena] price from DOM (' + sels[k] + '):', p5);
            return p5;
          }
        }
      }
    } catch(e){}

    console.warn('[BellaSirena] no price found, defaulting to 399');
    return 399;
  }

  function buildHTML(price){
    var total2 = (price*2) - DISCOUNT;
    var original2 = price*2;
    var blockStyle = 'background:#fdf2f8;border:1px solid #fce7f3;border-radius:16px;padding:18px 20px;margin:20px 0;font-family:Montserrat,sans-serif;display:block;width:100%;box-sizing:border-box;';
    var tagStyle = 'display:inline-flex;align-items:center;gap:8px;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:#831843;margin-bottom:8px;';
    var titleStyle = 'font-size:18px;font-weight:700;color:#ec4899;margin:4px 0 6px;line-height:1.2;';
    var pricesStyle = 'font-size:14px;color:#1a1a1a;font-weight:600;margin-bottom:8px;';
    var oldPriceStyle = 'text-decoration:line-through;color:#999;font-weight:400;margin-left:6px;';
    var descStyle = 'font-size:12px;color:#666;line-height:1.5;';
    var badgeStyle = 'display:inline-flex;align-items:center;gap:8px;background:#fff;border:1px solid #fbbf24;border-radius:100px;padding:6px 14px;font-size:11px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;color:#92400e;margin:12px 0;font-family:Montserrat,sans-serif;';
    var dotStyle = 'display:inline-block;width:8px;height:8px;border-radius:50%;background:#f59e0b;';
    var pinkDotStyle = 'display:inline-block;width:10px;height:10px;border-radius:50%;background:#ec4899;box-shadow:0 0 0 3px rgba(236,72,153,0.2);';

    return '<div class="bs-promo-wrapper" data-bs-v="' + VERSION + '" data-bs-price="' + price + '" style="display:block;margin:20px 0;">' +
      '<div class="bs-hot-sale-block" style="' + blockStyle + '">' +
        '<div class="bs-hot-sale-tag" style="' + tagStyle + '"><span style="' + pinkDotStyle + '"></span> HOT SALE México</div>' +
        '<div class="bs-hot-sale-title" style="' + titleStyle + '">Compra 2 y Ahorra $' + DISCOUNT + '</div>' +
        '<div class="bs-hot-sale-prices" style="' + pricesStyle + '">2 por <strong>$' + fmt(total2) + ' MXN</strong> <span style="' + oldPriceStyle + '">$' + fmt(original2) + ' MXN</span></div>' +
        '<div class="bs-hot-sale-desc" style="' + descStyle + '">Mezcla y combina cualquier traje de baño — lleva 2 piezas y disfruta de $' + DISCOUNT + ' OFF automático en el segundo artículo.</div>' +
      '</div>' +
      '<div class="bs-stock-bajo-badge" style="' + badgeStyle + '"><span style="' + dotStyle + '"></span> HOT SALE México · Stock Bajo</div>' +
    '</div>';
  }

  function findTarget(){
    var candidates = [
      function(){ var e = document.querySelector('variant-picker'); return e && {el:e, pos:'afterend'}; },
      function(){ var e = document.querySelector('.variant-picker'); return e && {el:e, pos:'afterend'}; },
      function(){ var e = document.querySelector('.variant-option:last-of-type'); return e && {el:e, pos:'afterend'}; },
      function(){ var e = document.querySelector('product-form-component'); return e && {el:e, pos:'beforebegin'}; },
      function(){ var e = document.querySelector('.product-form'); return e && {el:e, pos:'beforebegin'}; }
    ];
    for (var i=0; i<candidates.length; i++){
      try {
        var r = candidates[i]();
        if (r && r.el) return r;
      } catch(e){}
    }
    return null;
  }

  function doInject(){
    attempts++;
    if (!/\/products\//.test(location.pathname)) return false;
    if (document.querySelector('.bs-promo-wrapper')) { injected = true; return true; }
    var target = findTarget();
    if (!target) return false;
    var price = getPrice();
    var tmp = document.createElement('div');
    tmp.innerHTML = buildHTML(price);
    target.el.insertAdjacentElement(target.pos, tmp.firstChild);
    injected = true;
    console.log('[BellaSirena] ✅ inserted at attempt', attempts, 'with price', price);
    return true;
  }

  function start(){
    doInject();
    var interval = setInterval(function(){
      if (injected || attempts > 30) {
        clearInterval(interval);
        return;
      }
      doInject();
    }, 200);

    setTimeout(function(){
      try {
        new MutationObserver(function(){
          if (!/\/products\//.test(location.pathname)) return;
          if (!document.querySelector('.bs-promo-wrapper')) {
            injected = false;
            doInject();
          }
        }).observe(document.body, {childList:true, subtree:true});
      } catch(e){}
    }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
